import { apiRoutes, get, post } from './apiRoutes'
import config from '../config/vue.config'
import * as schema from './schema/appGatewayServer'
import i18n from '@/i18n'
import { getApiAuthToken } from '@/utils/token'
import { getDestinationHeader } from '@/utils/api_destination_header'

const defaultHeaders: { [k: string]: string | undefined } = {
  Authorization: undefined as string | undefined,
  'Accept-Language': i18n.locale,
  'X-VLIVE-CLIENT-TYPE': 'webapp',
  ...getDestinationHeader(),
}

const tree = {
  gacha: {
    getList: post<schema.ApiGachaListRespPayload>(),
    getItemList: post<
      schema.ApiGachaItemListReq,
      schema.ApiGachaItemListPayload
    >(),
  },
  media: {
    // media/get
    get: post<schema.ApiMediaGetRequest, schema.ApiMediaGetPayload>(),
  },
  live: {
    // live/comment
    comment: post<schema.ApiLiveCommentParam, void>(),
  },
  streamer: {
    owner: {
      // streamer/owner/get
      get: post<
        schema.ApiStreamerOwnerGetRequest,
        schema.ApiStreamerOwnerGetPayload
      >(),
    },
    follow: {
      // streamer/follow
      _: post<schema.ApiFollowParam, void>(),

      // streamer/follow/exists
      exists: post<
        schema.ApiFollowExistsParam,
        schema.ApiFollowExistsPayload
      >(),
    },
    currency: {
      coin: {
        purchase: {
          // streamer/currency/coin/purchase
          _: post<
            schema.ApiCurrencyCoinPurchaseParam,
            schema.ApiCurrencyCoinPurchasePayload
          >(),

          // streamer/currency/coin/purchase/ready
          ready: post<schema.ApiCurrencyCoinPurchaseReadyParam, void>(),

          // streamer/currency/coin/purchase/commit
          commit: post<schema.ApiCurrencyCoinPurchaseCommitParam, void>(),

          // streamer/currency/coin/purchase/update
          update: post<schema.ApiCurrencyCoinPurchaseUpdateParam, void>(),

          postpaid: {
            // streamer/currency/coin/purchase/postpaid/cancel
            cancel: post<
              schema.ApiCurrencyCoinPurchasePostpaidCancelParam,
              void
            >(),
          },
          // streamer/currency/coin/purchase/status
          status: post<
            schema.ApiCurrencyCoinPurchaseStatusParam,
            schema.ApiCurrencyCoinPurchaseStatusPayload
          >(),
          coin_bonus_product: {
            // streamer/currency/coin/purchase/coin_bonus_product/ready
            ready: post<
              schema.ApiCurrencyCoinPurchaseCoinBonusProductReadyParam,
              void
            >(),
          },
        },
        method: {
          // streamer/currency/coin/method/primary
          primary: post<schema.ApiCurrencyCoinMethodPrimaryParam, void>(),

          // streamer/currency/coin/method/detach
          detach: post<schema.ApiCurrencyCoinMethodDetachParam, void>(),
        },
      },
      live_point: {
        // streamer/currency/live_point/balance
        balance: post<schema.ApiCurrencyPointBalancePayload>(),
      },
    },
  },
  web: {
    mypage: {
      // web/mypage
      _: get<schema.ApiWebMypagePayload>(),

      // web/mypage/coin_histories
      coinHistories: get<
        schema.ApiWebMypageCoinHistoriesParam,
        schema.ApiWebMypageCoinHistoriesPayload
      >(),

      // web/mypage/coin_purchase
      coinPurchase: get<
        schema.ApiWebMypageCoinPurchaseParam,
        schema.ApiWebMypageCoinPurchasePayload
      >(),
    },
    log: {
      // web/log/write
      write: post<schema.ApiWebLogWriteParam, void>(),
    },
    payment: {
      // web/payment/record
      record: post<schema.ApiWebPaymentRecordParam, void>(),
    },
    coin: {
      // web/coin/check_purchasable
      checkPurchasable: post<
        schema.ApiWebCoinCheckPurchasableParam,
        schema.ApiWebCoinCheckPurchasablePayload
      >(),
      purchase: {
        // web/coin/purchase/cancel（課金制限予約の解放）
        cancel: post<schema.ApiWebCoinPurchaseCancelParam, void>(),
      },
    },
  },
  notice: {
    penalty: {
      getValid: post<
        schema.NoticePenaltyGetValidParam,
        schema.NoticePenaltyGetValidPayload
      >(),
    },
  },
  memoryAlbum: {
    get: post<schema.MemoryAlbumParam, schema.MemoryAlbumPayload>(),
  },
  reality_con_2025: {
    escapeGame: {
      join: post<void, void>(),
      joinStatus: get<schema.RealityCon2025JoinStatusPayload>(),
    },
  },
  maintenance: {
    allCheck: post<void>(),
  },
  obs: {
    get: {
      info: get<schema.ApiObsGetInfoPayload>(),
      token: get<schema.ApiObsGetTokenPayload>(),
    },
  },
  charge_grade_web: {
    prize_list: {
      get: get<
        schema.ApiChargeGradeWebGetPrizeListParam,
        schema.ApiChargeGradeWebGetPrizeListPayload
      >(),
    },
    check_in_web_purchase: get<
      schema.ApiChargeGradeWebCheckInWebPurchaseParam,
      schema.ApiChargeGradeWebCheckInWebPurchasePayload
    >(),
    vip_point: {
      get: get<void, schema.ApiChargeGradeWebGetVipPointPayload>(),
      issue: post<schema.ApiChargeGradeWebIssueVipPointParam, void>(),
      consume: post<schema.ApiChargeGradeWebConsumeVipPointParam, void>(),
      expire: post<void, void>(),
    },
    vip_point_history: {
      get: get<void, schema.ApiChargeGradeWebGetVipPointHistoryPayload>(),
    },
    continuous_count: {
      get: get<void, schema.ApiChargeGradeWebGetContinuousCountPayload>(),
    },
  },
  vip_point_shop: {
    // vip_point_shop/items
    items: post<schema.ApiVipPointShopItemListPayload>(),
    // vip_point_shop/exchange
    exchange: post<schema.ApiVipPointShopExchangeParam, void>(),
  },
}

const routePath = apiRoutes(
  `${config.appGatewayServerUrl}/api/v1`,
  defaultHeaders
)(tree)

export default routePath

// 実行時に各種ヘッダをセットするラッパー
export const api = () => {
  const token = getApiAuthToken()

  if (token) {
    defaultHeaders.Authorization = `Bearer ${token}`
  }

  return routePath
}
